export const getTimeLeft = (utcEndDateTime: string) => {
  const timeLeft = new Date(utcEndDateTime).getTime() - new Date().getTime()
  return timeLeft > 0 ? timeLeft : 0
}

export const delay = (ms: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms)
  })
